export class PqrPageClientInitEntity{
    
    id:number;
    nameLastName:string;
    nameLastNameFunction:string;
    email:string;
    emailFunction:string;
    emailAnex:string;   
    emailAnexFuntion:string;
    detailGeneral:string;
    detailGeneralFunction:string;
    documentsAnex:string;
    documentsAnexFuntion:string;
    titlePrincipal:string;
    paragraphTitle:string;
    languageId:number;
    creationDate:string;
    updateDate:string;
    active:boolean;
    constructor(){}
}